import { useLocalSearchParams } from 'expo-router'

import { IntentionThemeScreen } from '@/src/features/intention/ui/screens/IntentionThemeScreen/IntentionThemeScreen'

const IntentionThemePage = () => {
  const params = useLocalSearchParams<{ slug: string }>()
  const intentionSlug = params.slug

  return <IntentionThemeScreen landingPageSlug={intentionSlug} />
}

export default IntentionThemePage
